/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_TopicInputs */

const en_contact_form_topic = /** @type {(inputs: Contact_Form_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is it about?`)
};

const pl_contact_form_topic = /** @type {(inputs: Contact_Form_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czego dotyczy?`)
};

/**
* | output |
* | --- |
* | "What is it about?" |
*
* @param {Contact_Form_TopicInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_topic = /** @type {((inputs?: Contact_Form_TopicInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_TopicInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_topic(inputs)
	return en_contact_form_topic(inputs)
});